import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import StoryMidPromotion from "../../storyMidContent";
import { isPremium } from "../../../../../data/story";
import { ScrollPercentage } from "react-scroll-percentage";
import { PGAdwithAd } from "../../../../rows/ad-free";
import Media from "react-media";
import AudioPlayer from "../../../../pages/story/story-audioplayer";
function MagazineStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderFooterMagazine = get(props, ["renderFooterMagazine"], () => null);
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const story = get(props, ["story"], () => null);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const cardLength = cards.length;
  const evAccess = get(props, ["evAccess"]);
  const evAudioAccess = get(props, ["evAudioAccess"]);

  const [Percentage, serPercentage] = React.useState(0);

  useEffect(
    () => {
      GetStoryScrollPercentage(Percentage);
    },
    [Percentage]
  );
  const adShow = isPremium(story) ? !readMore : true;

  return (
    <div className="page-content">
      <div className={`container`}>
        <Media query="(max-width:768px)">
          <div className="mobile">
            <PGAdwithAd unit="Vikatan_mobile_article_leaderboard_top" class="ad-320x100" />
          </div>
        </Media>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        {renderSidebar(adShow)}
        <div className={styles["main-content"]}>
          <div>
            <ScrollPercentage>
              {({ percentage, ref, entry }) => {
                const percentageRound = percentage.toFixed(2) * 100;

                if (percentageRound) {
                  serPercentage(percentageRound);
                }
                return (
                  <article className={`${styles["story-body"]} js-story`} ref={ref}>
                    {renderHeaderCard()}
                    <HeroImage story={props.story} />
                    {renderSocialMedia()}
                    <p className={`subheadline-main ${styles["subheadline"]}`}>{storyHeadline}</p>
                    {evAudioAccess !== "ALLOW_ACCESS" ? <div /> : <AudioPlayer story={props.story} />}
                    <div className={evAccess !== "ALLOW_ACCESS" ? styles["story-card-wrapper"] : " "}>
                      {cards &&
                        cards.map((card, index) => {
                          return (
                            <React.Fragment key={card.id}>
                              {index === 1 && (
                                <div>{index === 1 ? <StoryMidPromotion story={props.story} /> : null}</div>
                              )}
                              <StoryCard
                                card={card}
                                story={props.story}
                                showCard={readMore}
                                cardLength={cardLength}
                                renderRelatedArticle={renderRelatedArticle}
                              />
                            </React.Fragment>
                          );
                        })}
                    </div>
                    {renderFooter(readMore)}
                  </article>
                );
              }}
            </ScrollPercentage>
            {renderFooterMagazine()}
          </div>
        </div>
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
MagazineStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func
};

export { MagazineStory };
